export const canSignInPortal = (permission) => {
  let { shop, staff, takeaway, report, product, estamp, promotionCode, welcome, ad, pushNotification } = permission;

  if (
    shop ||
    staff ||
    takeaway.length > 0 ||
    report.length > 0 ||
    product.issue ||
    estamp.issue ||
    promotionCode ||
    welcome ||
    ad ||
    pushNotification
  ) {
    return true;
  } else {
    return false;
  }
};

export const isSuper = (permission) => {
  return permission?.staff === true;
};
